// extracted by mini-css-extract-plugin
export default {"ExtensionContentHeader":"_ExtensionContentHeader--Hu2G6","ExtensionContentBody":"_ExtensionContentBody--aSOGb"};